import { useTranslation } from 'react-i18next';
import { siteConfig } from '../siteConfig';
import { Divider } from '../components/Divider';
import './Venue.css';

export function Venue() {
  const { t } = useTranslation();
  return (
    <section id="venue" className="section venue">
      <Divider />
      <div className="section-header">
        <div className="section-kicker">{t('venue.title')}</div>
        <h2 className="section-title">{t('venue.hotelName')}</h2>
      </div>

      <div className="venue__card">
        <div className="venue__card-inner">
          <div className="venue__address">{t('venue.address')}</div>
          <p className="venue__description">{t('venue.description')}</p>

          <div className="venue__links">
            <a
              href={siteConfig.links.venueMaps}
              target="_blank"
              rel="noreferrer noopener"
              className="btn btn--ghost"
            >
              {t('venue.mapLink')} ↗
            </a>
            <a
              href={siteConfig.links.venueWebsite}
              target="_blank"
              rel="noreferrer noopener"
              className="btn btn--ghost"
            >
              {t('venue.websiteLink')} ↗
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
